// removed by extract-text-webpack-plugin
module.exports = {"menu":"HeroMenuComponent__menu___2g6Xr","topMenu":"HeroMenuComponent__topMenu___2xBa_","sideMenu":"HeroMenuComponent__sideMenu___3M9Ex","item":"HeroMenuComponent__item___NH9y7","open":"HeroMenuComponent__open___2XIHb"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/heroMenu/HeroMenuComponent.scss
// module id = 160
// module chunks = 0